/* Фрейм с голосовалкой */
window.Vue = require('vue');
import PollFrame from './components/PollFrame.vue'

document.addEventListener("DOMContentLoaded", function() {
    const root = new Vue({
        el: '#vue-root',
        components: {
            PollFrame,
        }
    });
});
